<template>
  <div class="form-module">
    <p class="module-title">{{ $locale('schedule.priceRuleTemplate') }}</p>
    <el-form-item :label="$locale('global.name')" class="w387" prop="name">
      <el-input v-model="formObj.name" :placeholder="$locale('form.plsEnterYourName')"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "discountRuleTemplateBasicModule",
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
  },
};
</script>